import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ModalBottom } from '@ui/components/Modal'
import Button from '@ui/buttons/Button'

interface Props {
  open: boolean
  onClose: () => void
  onSignIn: () => void
  onCancel: () => void
}

export default function ExistingAccountFoundModal({
  open,
  onClose,
  onSignIn,
  onCancel,
}: Props) {
  const { t } = useTranslation(['modals', 'ui'])

  return (
    <ModalBottom
      open={open}
      close={onClose}
      title={t('modals:existingAccount.title')}
      desc={t('modals:existingAccount.desc')}
      spacedText
      body={
        <View className="flex-row items-center gap-8 px-16">
          <Button
            variant="filled"
            label={t('modals:existingAccount.signIn')}
            onPress={onSignIn}
          />
          <Button
            variant="outlined"
            label={t('modals:existingAccount.cancel')}
            onPress={onCancel}
          />
        </View>
      }
    />
  )
}
